export default {"src":"/_next/static/media/become-recruiter.782af980.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};